import { useNavigate, NavLink } from 'react-router-dom';
import {
	Layout,
	message,
	Row,
	Col,
	Card,
	Form,
	Input,
	Button,
	Space,
	Typography,
	Divider
} from 'antd';
import { restorePasswordRedux } from '../../store/auth/actions';
import { useDispatch } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { LockOutlined, MailTwoTone } from '@ant-design/icons';
import { reset } from 'numeral';
import ResetPassword from './resetPassword';
import { useState } from 'react';
const logoBE = require('../../assets/onboarding/logoBE.png');
const EV = require('../../assets/EngelLogo.png');
const EVMoBile = require('../../assets/EngelLogoMobile.png');

const { Content } = Layout;
const { Text } = Typography;

const ForgotPassword = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [sendEmail, setSendEmail] = useState(false);
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		dispatch(restorePasswordRedux({ email: values.username }));
		setSendEmail(true);
		form.resetFields();
	};

	const onFinishFailed = () => {
		message.error('Debe completar todos los datos');
	};

	return (
		<Layout
			style={{
				width: isMobileOnly ? 400 : undefined,
				marginTop: -5,
				background: '#FCFAF5'
			}}>
			<div style={{ height: isMobileOnly ? 56 : 68, background: 'white' }}>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
					{isMobileOnly ? (
						<img src={EVMoBile} alt="EV" style={{ width: 109, height: 24 }}></img>
					) : (
						<img src={EV} alt="EV" style={{ width: 212, height: 16 }}></img>
					)}
				</div>
			</div>
			<Content
				style={{
					marginTop: !isMobileOnly ? '5%' : undefined,

					height: !isMobileOnly ? '100vh' : undefined,
					padding: isMobileOnly && 24,
					height: '100vh',
					marginRight: !isMobileOnly ? undefined : 8
				}}>
				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
					<Text style={{ fontSize: isMobileOnly ? 20 : 32, fontWeight: 700, color: '#262626' }}>
						{t('login.text')}
					</Text>
				</div>
				<Row justify="space-around" align="middle">
					<Col lg={6} md={12} xs={24} sm={24}>
						<Card className="card-login">
							<Form form={form} name="login" onFinish={onFinish} onFinishFailed={onFinishFailed}>
								<Form.Item>{t('email.reset')}</Form.Item>
								<Form.Item
									name="username"
									rules={[{ required: true, message: 'Introduzca su email' }]}>
									<Input className={'login-input'} type="email" placeholder="Email" />
								</Form.Item>
								<Form.Item>
									<Button
										htmlType="submit"
										block
										className="button-secundary-ev"
										style={{ height: isMobileOnly && 48 }}>
										{t('send.EmailReset')}
									</Button>
								</Form.Item>
								<Form.Item style={{ textAlign: 'center' }}>
									<Space>
										<NavLink to="/login">
											<Text style={{ color: '#404040', fontSize: 14, fontWeight: 400 }}>
												{t('back.login')}
											</Text>
										</NavLink>
									</Space>
								</Form.Item>

								{sendEmail && (
									<Text style={{ color: '#05c69a', fontSize: 14, fontWeight: 400 }}>
										{t('send.EmailReset2')}
									</Text>
								)}
							</Form>
						</Card>
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default ForgotPassword;
